<div class="pages-container" (mouseenter)="enableHover()" (mouseleave)="disableHover()">
  <ul class="pages kb-scrollbar">
    @for (page of pages; track page; let firstPage = $first; let pageIndex = $index) {
      <li class="page" [class.active]="isPageActive(page, pageIndex)" [attr.items]="isMultiItemPage(page) ? page.length : null">
        @if (isMultiItemPage(page)) {
          <ul class="item-container multi-item-container">
            @for (item of page; track item; let firstItem = $first; let itemIndex = $index) {
              <li [class.active]="isItemActive(pageIndex, itemIndex)">
                <kb-hero-item
                  class="embedded"
                  [aboveFold]="firstPage && (!isMobile || firstItem)"
                  [item]="item"
                  [rootColumns]="firstItem ? 8 : 4"
                  [indented]="firstItem && page.length === 3"
                  [largeHeading]="firstItem && page.length === 3"
                  [abstractMode]="abstractMode"
                />
              </li>
            }
          </ul>
        } @else {
          <kb-hero-item
            class="embedded item-container single-item-container"
            [aboveFold]="firstPage"
            [item]="page"
            [rootColumns]="12"
            [indented]="true"
            [largeHeading]="true"
            [abstractMode]="abstractMode"
          />
        }
      </li>
    }
  </ul>
  @if (pages.length > 1 || isMultiItemPage(pages[0])) {
    <button type="button" class="page-button previous-page-button" [class.hide-on-desktop]="pages.length === 1" kb-icon icon-uppercase icon-center [icon]="iconArrowLeft" [attr.aria-label]="intl.previousPageButtonLabel" (click)="openPreviousPage()"></button>
    <button type="button" class="page-button next-page-button" [class.hide-on-desktop]="pages.length === 1" kb-icon icon-uppercase icon-center [icon]="iconArrowRight" [attr.aria-label]="intl.nextPageButtonLabel" (click)="openNextPage()"></button>
  }
</div>
<ul class="page-controls">
  @for (page of pages; track page; let pageIndex = $index) {
    @if (isMultiItemPage(page)) {
      <li class="multi-item-controls" [class.hide-on-desktop]="pages.length === 1">
        <button type="button" (click)="navigatePageIndex(getAbsolutePageIndex(pageIndex))" [class.active]="isPageActive(page, pageIndex)" class="page-control multi-item-control" [attr.aria-label]="'Page ' + (getAbsolutePageIndex(pageIndex) + 1)"></button>
        <ul class="item-controls">
          @for (item of page; track item; let itemIndex = $index) {
            <li>
              <button type="button" (click)="navigatePageIndex(getAbsoluteItemIndex(pageIndex, itemIndex))" [class.active]="isItemActive(pageIndex, itemIndex)" class="page-control item-control" [attr.aria-label]="'Page ' + (getAbsoluteItemIndex(pageIndex, itemIndex) + 1)"></button>
            </li>
          }
        </ul>
      </li>
    } @else if(pages.length > 1) {
      <li>
        <button type="button" (click)="navigatePageIndex(getAbsolutePageIndex(pageIndex))" [class.active]="isPageActive(page, pageIndex)" class="page-control" [attr.aria-label]="'Page ' + (getAbsolutePageIndex(pageIndex) + 1)"></button>
      </li>
    }
  }
</ul>
